import { useEffect, useState } from 'react';

export default function useToggleDropdown(
  toggleButtonRef: React.RefObject<HTMLButtonElement | null>,
) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const onDocClick = (event: MouseEvent) => {
      const { target } = event as { target: Node | null };
      if (toggleButtonRef.current?.contains(target)) {
        setIsOpen((prev) => !prev);
        return;
      }

      setIsOpen(false);
    };

    document.addEventListener('click', onDocClick);

    return () => document.removeEventListener('click', onDocClick);
  }, [toggleButtonRef]);

  return isOpen;
}
